import React, { useState } from "react"
import ReactPlayer from "react-player"
import Section from "@components/section"
import Button from "@components/button"
import Title from "@components/title"
import Frame from "@components/frame"
import Glow from "@components/glow"
import BottomContainer from "@components/bottomContainer"
import styles from "./plot.module.scss"
import config from "@config"

import radiosImage from "@images/arc-plot.png"
import avatar42Img from "@images/42.png"
import albumImg from "@images/album.png"
import playImg from "@images/record-play-icon.png"
import pauseImg from "@images/record-pause-icon.png"

import recordMp3 from "@images/record.mp3"
import progressSvg from "@images/progress.svg"

const Player = ({ playing, setPlaying }) => {
  const [played, setPlayed] = useState(0)
  return (
    <>
      <ReactPlayer
        url={recordMp3}
        playing={playing}
        style={{ display: "none" }}
        config={{
          file: { forceAudio: true, attributes: { preload: "metadata" } },
        }}
        onProgress={time => {
          const { played } = time
          setPlayed(played)
        }}
        onEnded={() => {
          setPlayed(0)
          setPlaying(false)
        }}
      />
      <div className={styles.player}>
        <img src={avatar42Img} alt="42 avatar" />
        <div className={styles.playerBody}>
          <h3>
            <span>
              <b>行动发起者</b>
              <b>四十二</b>
            </span>
            <span>VOCAL</span>
          </h3>
          <div className={styles.progressBar}>
            <div
              className={styles.progressBarCurrent}
              style={{ width: `${played * 100}%` }}
            />
            <img src={progressSvg} />
          </div>
        </div>
      </div>
    </>
  )
}

const Plot = React.memo(props => {
  const [playing, setPlaying] = useState(false)
  return (
    <Section>
      <Title
        sub={
          <>
            由西蒙、nadya、龙马、27组成的「吉考斯特别行动小组」执行外出探索任务，
            <br />
            然而传回总部的确是他们发出的一段预警信息：时空浩劫即将来袭，宇宙将万劫不复...
            <br />
            吉考斯工业紧急启动了宇宙救援行动，任务代号「弧光」
          </>
        }
      >
        了解「弧光行动」的源头
      </Title>

      <div className={styles.cols}>
        <div>
          <div className={styles.colBody}>
            <Glow className={styles.playerGlow} lighter>
              <Frame className={styles.playerFrame} type="dark">
                <Player playing={playing} setPlaying={setPlaying} />
              </Frame>
            </Glow>
          </div>
          <BottomContainer className={styles.buttons}>
            <Frame
              type="button"
              plain
              className={styles.playIcon}
              onClick={() => {
                setPlaying(p => !p)
              }}
            >
              <img src={playing ? pauseImg : playImg} />
            </Frame>
          </BottomContainer>
        </div>
        <div>
          <div className={styles.colBody}>
            <Glow className={styles.albumGlow} lighter>
              <img src={albumImg} />
            </Glow>
          </div>
          <BottomContainer className={styles.buttons}>
            <Frame type="button" href={config.urls.album}>
              收听完整故事
            </Frame>
          </BottomContainer>
        </div>
      </div>
    </Section>
  )
})

Plot.displayName = "ArcPlot"
export default Plot
